import { render, staticRenderFns } from "./PerfilDados.vue?vue&type=template&id=e84c9bc0&scoped=true"
import script from "./PerfilDados.vue?vue&type=script&lang=js"
export * from "./PerfilDados.vue?vue&type=script&lang=js"
import style0 from "./PerfilDados.vue?vue&type=style&index=0&id=e84c9bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84c9bc0",
  null
  
)

export default component.exports